import * as XLSX from 'xlsx';

// ── Default master template definition with headers and sample data ──
export const MASTER_TEMPLATE_SHEETS = {
  residents: {
    sheetName: '1. Residentes y Unidades',
    headers: [
      'Unidad',
      'Nombre Residente',
      'Correo',
      'Teléfono',
      'Monto Ordinarias ($)',
      'Meses Ordinarias (Qty)',
      'Monto Extraordinarias ($)',
      'Qty Extraordinarias',
      'Monto Multas ($)',
      'Qty Multas',
      'Convenio Activo (Sí/No)',
      'Monto Convenio ($)',
      'Es Comité (Sí/No)'
    ],
    sampleRows: [
      ['Casa 10', 'Juan Pérez', 'juan.perez@example.com', '5512345678', 1650, 3, 0, 0, 200, 1, 'No', 0, 'No'],
      ['Casa 11', 'María López', 'maria.lopez@example.com', '5587654321', 0, 0, 0, 0, 0, 0, 'No', 0, 'Sí'],
      ['Casa 12', 'Roberto Gómez', 'roberto.gomez@example.com', '5599887766', 3000, 6, 500, 1, 0, 0, 'Sí', 3000, 'No']
    ]
  },
  balance: {
    sheetName: '2. Balanza Inicial Contable',
    headers: ['Código Cuenta SAT', 'Nombre Cuenta', 'Debe (Saldo Inicial)', 'Haber (Saldo Inicial)'],
    sampleRows: [
      ['102.01', 'Bancos Nacionales', 50000, 0],
      ['105.01', 'Cuotas por Cobrar (Residentes)', 5350, 0],
      ['120.01', 'Anticipo a Proveedores', 0, 0],
      ['201.01', 'Proveedores Nacionales', 0, 15000],
      ['206.01', 'Cuotas Cobradas por Anticipado', 0, 0],
      ['301.01', 'Patrimonio / Fondo Inicial', 0, 40350]
    ]
  },
  vendors: {
    sheetName: '3. Proveedores',
    headers: ['RFC', 'Razón Social', 'Nombre Comercial', 'Categoría', 'Correo Contacto', 'Banco', 'CLABE Interbancaria'],
    sampleRows: [
      ['SEG990101ABC', 'Seguridad Privada Protec SA de CV', 'Protec Seguridad', 'Seguridad', 'contacto@protec.com', 'BBVA', '012180001234567890'],
      ['LIM050512XYZ', 'Servicios de Limpieza Condominal SRL', 'Limpieza Pro', 'Limpieza', 'ventas@limpiezapro.com', 'Banorte', '072180009876543210']
    ]
  },
  staff: {
    sheetName: '4. Staff y Seguridad',
    headers: ['Nombre Completo', 'Correo', 'Rol', 'Turno'],
    sampleRows: [
      ['Carlos Ramírez', 'carlos.caseta@condo.com', 'Vigilante', 'Matutino 12x12'],
      ['Lucía Hernández', 'lucia.admin@condo.com', 'Administrador Auxiliar', 'Tiempo Completo']
    ]
  },
  amenities: {
    sheetName: '5. Amenidades y Reglas',
    headers: [
      'Nombre',
      'Descripción',
      'Costo Reserva ($)',
      'Horario Apertura (HH:MM)',
      'Horario Cierre (HH:MM)',
      'Duración Bloque (Min)',
      'Horas Anticipación (Qty)',
      'Capacidad Simultánea',
      'Límite Invitados',
      'Límite Reservas',
      'Requiere Depósito (Sí/No)',
      'Monto Depósito ($)'
    ],
    sampleRows: [
      ['Casa Club', 'Salón de eventos principales con asador', 500, '09:00', '22:00', 120, 24, 1, 20, 1, 'Sí', 1000],
      ['Alberca', 'Área de alberca común y camastros', 0, '08:00', '20:00', 60, 2, 4, 6, 2, 'No', 0]
    ]
  },
  config: {
    sheetName: '6. Configuración Condominio',
    headers: [
      'Costo Cuota Ordinaria ($)',
      'Día de Generación (1-28)',
      'Día de Vencimiento (1-28)',
      'Tipo Recargo',
      'Monto/Porcentaje Recargo',
      'Delay Peatonal Morosos (Segs)',
      'Bloquear Visitas por Adeudo (Sí/No)',
      'Bloquear Votación por Adeudo (Sí/No)'
    ],
    sampleRows: [
      [550, 1, 10, 'Porcentaje', 10, 10, 'Sí', 'Sí']
    ]
  },
  agreements: {
    sheetName: '7. Convenios de Pago',
    headers: ['Unidad', 'Deuda Conveniada ($)', 'Plazos Totales', 'Plazos Pagados', 'Monto Mensualidad ($)'],
    sampleRows: [
      ['Casa 12', 3000, 6, 2, 500]
    ]
  }
};

/**
 * Downloads the master 7-sheet Excel template for Kondify onboarding.
 */
export const downloadMasterTemplate = () => {
  const wb = XLSX.utils.book_new();

  Object.values(MASTER_TEMPLATE_SHEETS).forEach(sheetDef => {
    const data = [sheetDef.headers, ...sheetDef.sampleRows];
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Set column widths based on headers
    const colWidths = sheetDef.headers.map(h => ({ wch: Math.max(h.length + 4, 15) }));
    ws['!cols'] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, sheetDef.sheetName);
  });

  XLSX.writeFile(wb, 'Kondify_Onboarding_Template.xlsx');
};

/**
 * Parses an uploaded Excel (.xlsx/.xls/csv) file and extracts data for each of the 7 tabs.
 */
export const parseMasterExcelFile = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: 'array' });

        const result = {
          residents: [],
          balance: [],
          vendors: [],
          staff: [],
          amenities: [],
          config: [],
          agreements: []
        };

        const sheetNames = wb.SheetNames;

        const findSheet = (prefixOrName) => {
          const foundName = sheetNames.find(s => 
            s.toLowerCase().includes(prefixOrName.toLowerCase())
          );
          return foundName ? wb.Sheets[foundName] : null;
        };

        // 1. Residents
        const resSheet = findSheet('1.') || findSheet('residentes') || wb.Sheets[sheetNames[0]];
        if (resSheet) {
          const rows = XLSX.utils.sheet_to_json(resSheet, { header: 1 });
          if (rows.length > 1) {
            result.residents = rows.slice(1).filter(r => r && r[0]).map((r, i) => ({
              id: `res_${i}_${Date.now()}`,
              unidad: String(r[0] || '').trim(),
              nombreResidente: String(r[1] || '').trim(),
              correo: String(r[2] || '').trim(),
              telefono: String(r[3] || '').trim(),
              montoOrdinarias: Number(r[4]) || 0,
              mesesOrdinariasQty: Number(r[5]) || 0,
              montoExtraordinarias: Number(r[6]) || 0,
              qtyExtraordinarias: Number(r[7]) || 0,
              montoMultas: Number(r[8]) || 0,
              qtyMultas: Number(r[9]) || 0,
              convenioActivo: String(r[10] || 'No').trim(),
              montoConvenio: Number(r[11]) || 0,
              esComite: String(r[12] || 'No').trim()
            }));
          }
        }

        // 2. Balanza Contable
        const balSheet = findSheet('2.') || findSheet('balanza');
        if (balSheet) {
          const rows = XLSX.utils.sheet_to_json(balSheet, { header: 1 });
          if (rows.length > 1) {
            result.balance = rows.slice(1).filter(r => r && (r[0] || r[1])).map((r, i) => ({
              id: `bal_${i}_${Date.now()}`,
              codigoCuenta: String(r[0] || '').trim(),
              nombreCuenta: String(r[1] || '').trim(),
              debe: Number(r[2]) || 0,
              haber: Number(r[3]) || 0
            }));
          }
        }

        // 3. Proveedores
        const venSheet = findSheet('3.') || findSheet('proveedores');
        if (venSheet) {
          const rows = XLSX.utils.sheet_to_json(venSheet, { header: 1 });
          if (rows.length > 1) {
            result.vendors = rows.slice(1).filter(r => r && (r[0] || r[1])).map((r, i) => ({
              id: `ven_${i}_${Date.now()}`,
              rfc: String(r[0] || '').trim(),
              razonSocial: String(r[1] || '').trim(),
              nombreComercial: String(r[2] || '').trim(),
              categoria: String(r[3] || 'General').trim(),
              correoContacto: String(r[4] || '').trim(),
              banco: String(r[5] || '').trim(),
              clabe: String(r[6] || '').trim()
            }));
          }
        }

        // 4. Staff
        const stfSheet = findSheet('4.') || findSheet('staff');
        if (stfSheet) {
          const rows = XLSX.utils.sheet_to_json(stfSheet, { header: 1 });
          if (rows.length > 1) {
            result.staff = rows.slice(1).filter(r => r && (r[0] || r[1])).map((r, i) => ({
              id: `stf_${i}_${Date.now()}`,
              nombreCompleto: String(r[0] || '').trim(),
              correo: String(r[1] || '').trim(),
              rol: String(r[2] || 'Vigilante').trim(),
              turno: String(r[3] || '').trim()
            }));
          }
        }

        // 5. Amenidades
        const ameSheet = findSheet('5.') || findSheet('amenidades');
        if (ameSheet) {
          const rows = XLSX.utils.sheet_to_json(ameSheet, { header: 1 });
          if (rows.length > 1) {
            result.amenities = rows.slice(1).filter(r => r && r[0]).map((r, i) => ({
              id: `ame_${i}_${Date.now()}`,
              nombre: String(r[0] || '').trim(),
              descripcion: String(r[1] || '').trim(),
              costoReserva: Number(r[2]) || 0,
              horarioApertura: String(r[3] || '09:00').trim(),
              horarioCierre: String(r[4] || '21:00').trim(),
              duracionBloque: Number(r[5]) || 60,
              horasAnticipacion: Number(r[6]) || 24,
              capacidadSimultanea: Number(r[7]) || 1,
              limiteInvitados: Number(r[8]) || 10,
              limiteReservas: Number(r[9]) || 1,
              requiereDeposito: String(r[10] || 'No').trim(),
              montoDeposito: Number(r[11]) || 0
            }));
          }
        }

        // 6. Configuración
        const cfgSheet = findSheet('6.') || findSheet('configuraci');
        if (cfgSheet) {
          const rows = XLSX.utils.sheet_to_json(cfgSheet, { header: 1 });
          if (rows.length > 1) {
            const r = rows[1];
            if (r) {
              result.config = [{
                costoCuotaOrdinaria: Number(r[0]) || 550,
                diaGeneracionCuota: Number(r[1]) || 1,
                diaVencimientoCuota: Number(r[2]) || 10,
                tipoRecargo: String(r[3] || 'Porcentaje').trim(),
                montoRecargo: Number(r[4]) || 10,
                delayPeatonalMorosos: Number(r[5]) || 10,
                bloquearVisitasPorAdeudo: String(r[6] || 'Sí').trim(),
                bloquearVotacionPorAdeudo: String(r[7] || 'Sí').trim()
              }];
            }
          }
        }

        // 7. Convenios
        const agrSheet = findSheet('7.') || findSheet('convenios');
        if (agrSheet) {
          const rows = XLSX.utils.sheet_to_json(agrSheet, { header: 1 });
          if (rows.length > 1) {
            result.agreements = rows.slice(1).filter(r => r && r[0]).map((r, i) => ({
              id: `agr_${i}_${Date.now()}`,
              unidad: String(r[0] || '').trim(),
              deudaConveniada: Number(r[1]) || 0,
              plazosTotales: Number(r[2]) || 1,
              plazosPagados: Number(r[3]) || 0,
              montoMensualidad: Number(r[4]) || 0
            }));
          }
        }

        resolve(result);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
};
